var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSystemspil = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.018.982A3.33,3.33,0,0,0,14.648,0H3.352A3.352,3.352,0,0,0,0,3.352v11.3A3.355,3.355,0,0,0,3.352,18h11.3A3.355,3.355,0,0,0,18,14.648V3.352A3.33,3.33,0,0,0,17.018.982ZM5.831,6.339l2.8-2.8a.527.527,0,0,1,.746,0l2.8,2.8a.527.527,0,1,1-.746.746l-1.9-1.9v5.626a.527.527,0,0,1-1.055,0V5.19l-1.9,1.9a.527.527,0,1,1-.746-.746Zm8.252,8.271H3.916a.527.527,0,0,1,0-1.055H14.084a.527.527,0,1,1,0,1.055Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSystemspil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/systemspil.e64aa8d5.svg";
export { ForwardRef as ReactComponent };